import { config } from "./interface";

export const configReducer = (state = config) => {
  return state;
};
